//
import { resourceSagaUtils, resourceStoreTypes } from 'app-components/flux/core';
import { takeEvery } from 'redux-saga/effects';

import * as actions from './transferHistoryActions';
import { getLastSyncDate } from './transferHistorySelectors';
import { mkTransferHistory } from './transferHistoryTypes';

/*  const mkResourceConfig = (props) => resourceStoreTypes.mkQcsSyncResourceConfig({
  resourceName: 'transfer history',
  resourceBaseUrl: '/transfers/',
  getLastSyncDate,
  transformResponseToResources: (response) => response.data && response.data.resources && response.data.resources.map((data) => mkInvestmentHoldingV2(data)),
  ...props,
}); */

export function* getTransferHistoryActionWatcher() {
  const config = resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'transfer history',
    resourceBaseUrl: '/transfers',
    getLastSyncDate,
    successAction: actions.getTransferHistorySuccess,
    failureAction: actions.getTransferHistoryFailure,
    transformResponseToResources: (response) =>
      response.data && response.data.resources && response.data.resources.map((data) => mkTransferHistory(data)),
  });
  yield takeEvery(actions.getTransferHistory, resourceSagaUtils.qcsSyncGetResources, config);
}

export function* cancelTransferActionWatcher() {
  const config = resourceStoreTypes.mkQcsSyncResourceConfig({
    resourceName: 'transfer history',
    resourceBaseUrl: (action) => `/transfers/${action.payload.transferId}/cancel`, // action.payload.action
    successAction: actions.cancelTransferActionSuccess,
    failureAction: actions.cancelTransferActionFailure,
    //  transformResourceToRequestData: () => undefined, // no request body
    transformResourceWithResponse: (resource, response) =>
      mkTransferHistory({ ...(resource.toJS?.() || resource), ...response.data.resource }),
  });

  yield takeEvery(actions.cancelTransferAction, resourceSagaUtils.qcsSyncCreateResource, config);
}

export default [cancelTransferActionWatcher, getTransferHistoryActionWatcher];
